import { useMemo } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { RenewalStatus } from "@covertree/agent-portal-graphql";

import { AGENT_HELP_ADDRESS } from "@consts/index";

import { RenewalDetailsContentProps } from "@routing/routes/Renewals/RenewalDetails/RenewalDetailsContent/ContentTabs/types";

import {
  Description,
  NonRenewalIssuedDetails,
  DiscardDetails,
  PolicyDetails,
} from "./OverviewSections";

interface Props extends RenewalDetailsContentProps {
  error: boolean;
}

export function Overview({ renewal, loading, error }: Props) {
  const isDiscarded = useMemo(
    () => renewal?.status === RenewalStatus.Discarded,
    [renewal]
  );

  const isNonRenewalIssued = useMemo(
    () => renewal?.status === RenewalStatus.NonRenewalIssued,
    [renewal]
  );

  if (!loading && error) {
    return (
      <Box>
        <Typography variant="subtitle1" color="black" textAlign="center">
          Renewal was not found. Please contact us via email at{" "}
          <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
            {AGENT_HELP_ADDRESS}
          </Link>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      <PolicyDetails renewal={renewal} loading={loading} />
      {renewal && isDiscarded && (
        <DiscardDetails renewal={renewal} loading={loading} />
      )}
      {renewal && !isNonRenewalIssued && (
        <Description renewal={renewal} loading={loading} />
      )}
      {renewal && isNonRenewalIssued && (
        <NonRenewalIssuedDetails renewal={renewal} loading={loading} />
      )}
    </Grid>
  );
}
